export const CATALOG_CATEGORIES = 'catalog_categories';
export const CATALOG_ITEMS = 'catalog_items';

export function catalogItemDocumentId(categoryId: string, itemId: number): string {
  return `${categoryId}__${itemId}`;
}
